import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {PageHeadingConfig, PageHeading} from "./page_heading"

export const pageHeadingLoader = function(){
    componentLoader(componentConfig(PageHeading, PageHeadingConfig.componentTypeKey, PageHeadingConfig.baseHtmlClass));
};

